import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-linkedin",
  templateUrl: "./med-icon-linkedin.component.html",
})
export class MedIconLinkedinComponent extends SvgMixinComponent {}
